export default __webpack_public_path__ + "static/5905v5907_2-ffb610a1c918c113b2a6e4c5eb7f072f.webp";